module.exports = __webpack_public_path__ + "img/聚跃倾斜logo.da679fc4.png";